<span *ngIf="lastSyncedAt">
  Pushed <mode-time-ago [date]="lastSyncedAt" [tooltipIsDisabled]="true"></mode-time-ago>
</span>
<span *ngIf="!lastSyncedAt">
  {{ neverSyncedLabel }}
</span>
<capra-icon
  *ngIf="hasUnsyncedChanges"
  icon="icon-github-unsynced"
  capraTooltip
  [tooltipInteractive]="false"
  [tooltipContent]="unsyncedLabel"
  tooltipPlacement="bottom"
  tooltipSize="regular"
>
</capra-icon>
